import { locales, SUPPORTED_LANGUAGES, DEFAULT_LCID } from "../config";
import LocalesApi from "../services/LocalesApi";
import { LocaleStateStatus, Translations } from "../types";
import { BehaviorSubject } from "rxjs";
import { Dispatch, SetStateAction } from "react";

export class LocaleService {
  isRtl: boolean = false;
  localeName?: string;
  translations: Translations = {};
  state = LocaleStateStatus.PENDING;
  languages = SUPPORTED_LANGUAGES;
  lcid: number = DEFAULT_LCID;
  currentTranslations$ = new BehaviorSubject<{}>({});
  locale$ = new BehaviorSubject<string>("");

  public get locale() {
    return this.locale$.value;
  }

  public get currentTranslations() {
    return this.currentTranslations$.value;
  }

  getLocale = () => {
    return this.locale$.asObservable();
  };

  subscribeLocale = (setLocale: Dispatch<SetStateAction<string>>) => {
    return this.locale$.subscribe(setLocale);
  };

  subscribeTranslations = (setCurrentTranslations: Dispatch<SetStateAction<{}>>) => {
    return this.currentTranslations$.subscribe(setCurrentTranslations);
  };

  initLocale = async (locale: string) => {
    this.locale$.next(locale);
    this.lcid = locales[locale].lcid;
    this.isRtl = locales[locale].isRtl;
    this.localeName = locales[locale].shortName;
    if (!this.translations[locale]) {
      this.state = LocaleStateStatus.PENDING;
      try {
        this.translations[locale] = await LocalesApi.getTranslations(locale);
      } catch {
        //TODO Добавить обработчик ошибок статусов бека
        // eslint-disable-next-line no-console
        console.error("Error get locale");
      }
      this.state = LocaleStateStatus.OK;

      this.currentTranslations$.next(this.translations[locale]);
    }
  };
}

export default new LocaleService();
